// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__Gd8hm","tab":"ProcedureTabs_tab__27gjE"};